document.documentElement.classList.remove('no-js');

const q = (selector, scope = document) => scope.querySelector(selector);
const qa = (selector, scope = document) => [...scope.querySelectorAll(selector)];

function initHeader() {
  qa('[data-mobile-menu]').forEach((button) => {
    button.addEventListener('click', () => {
      const nav = q('#MobileNav');
      if (!nav) return;
      const open = nav.classList.toggle('is-open');
      button.setAttribute('aria-expanded', String(open));
    });
  });
}

function openCart() {
  const drawer = q('#CartDrawer');
  if (!drawer) return;
  drawer.setAttribute('aria-hidden', 'false');
  document.body.classList.add('drawer-open');
  q('[data-cart-close]', drawer)?.focus();
}

function closeCart() {
  const drawer = q('#CartDrawer');
  if (!drawer) return;
  drawer.setAttribute('aria-hidden', 'true');
  document.body.classList.remove('drawer-open');
}

function initCartDrawer() {
  qa('[data-cart-open]').forEach((button) => button.addEventListener('click', (event) => {
    event.preventDefault();
    openCart();
  }));
  qa('[data-cart-close]').forEach((button) => button.addEventListener('click', closeCart));
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeCart();
  });
}

async function refreshCartDrawer(openAfter = false) {
  const response = await fetch(`${window.Shopify?.routes?.root || '/'}?section_id=cart-drawer`, {
    headers: { 'X-Requested-With': 'XMLHttpRequest' }
  });
  if (!response.ok) throw new Error('Unable to refresh cart');
  const html = await response.text();
  const parsed = new DOMParser().parseFromString(html, 'text/html');
  const fresh = q('#CartDrawer', parsed);
  const current = q('#CartDrawer');
  if (fresh && current) current.replaceWith(fresh);
  initCartDrawer();
  if (openAfter) openCart();
}

function initProductForms() {
  qa('[data-product-form]').forEach((form) => {
    if (form.dataset.enhanced === 'true') return;
    form.dataset.enhanced = 'true';
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const submit = q('[type="submit"]', form);
      const error = q('[data-product-error]', form);
      submit?.setAttribute('disabled', 'disabled');
      if (error) error.textContent = '';
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' },
          body: new FormData(form)
        });
        const data = await response.json();
        if (!response.ok) throw new Error(data.description || 'Unable to add item');
        await refreshCartDrawer(true);
      } catch (err) {
        if (error) error.textContent = err.message;
      } finally {
        submit?.removeAttribute('disabled');
      }
    });
  });
}

function initQuantityButtons() {
  qa('[data-quantity]').forEach((wrap) => {
    const input = q('input', wrap);
    qa('button', wrap).forEach((button) => button.addEventListener('click', () => {
      const change = Number(button.dataset.change || 0);
      const min = Number(input.min || 0);
      const next = Math.max(min, Number(input.value || 0) + change);
      input.value = String(next);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }));
  });
}

function initVariantSelectors() {
  qa('[data-product-section]').forEach((section) => {
    const jsonNode = q('[data-product-json]', section);
    if (!jsonNode) return;
    let product;
    try { product = JSON.parse(jsonNode.textContent); } catch (_) { return; }
    const optionGroups = qa('[data-option-position]', section);
    optionGroups.forEach((group) => group.addEventListener('change', () => {
      const selected = optionGroups.map((g) => q('input:checked', g)?.value);
      const variant = product.variants.find((v) => v.options.every((opt, i) => opt === selected[i]));
      const idInput = q('input[name="id"]', section);
      const button = q('[data-add-button]', section);
      const price = q('[data-product-price]', section);
      if (!variant) {
        if (button) { button.disabled = true; button.textContent = 'Unavailable'; }
        return;
      }
      if (idInput) idInput.value = variant.id;
      if (button) {
        button.disabled = !variant.available;
        button.textContent = variant.available ? button.dataset.addText : 'Sold out';
      }
      if (price) {
        const money = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
          style: 'currency', currency: window.Shopify?.currency?.active || 'USD'
        }).format(cents / 100);
        price.innerHTML = `${variant.compare_at_price > variant.price ? `<span class="price__compare">${money(variant.compare_at_price)}</span>` : ''}<span class="price__regular">${money(variant.price)}</span>`;
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    }));
  });
}

function initFilters() {
  qa('[data-filter-toggle]').forEach((button) => button.addEventListener('click', () => {
    q('[data-facets]')?.classList.toggle('is-open');
  }));
}

function init() {
  initHeader();
  initCartDrawer();
  initProductForms();
  initQuantityButtons();
  initVariantSelectors();
  initFilters();
}

document.addEventListener('DOMContentLoaded', init);
document.addEventListener('shopify:section:load', init);
